import PropTypes from 'prop-types';
import React, { memo, useCallback, useContext } from 'react';

import { UserAnalyticsService, useUserAnalyticsContext } from 'fr-shared/context';

import { PartCard, PartPreviewModal } from 'portal/components';
import { PartsContext } from 'portal/contexts/PartsContext';
import { PartModel } from 'portal/types/parts';

interface PartViewProps {
  pageName: string;
  part: PartModel;
}

const PartView = ({ part, pageName }: PartViewProps) => {
  const { handleSelectPart, selectedParts } = useContext(PartsContext);
  const userAnalytics: UserAnalyticsService = useUserAnalyticsContext();
  const isPartSelected = !!selectedParts[part.id];
  const logOnSelection = () =>
    userAnalytics.track(`Select Part - ${pageName}`, { valid: !isPartSelected });
  const logOnClickPart = () =>
    userAnalytics.track(`${pageName} - View Part`, { valid: !isPartSelected });
  const handleSelectClick = useCallback(() => {
    handleSelectPart(isPartSelected, part);
  }, [handleSelectPart, isPartSelected, part]);

  return (
    <PartPreviewModal
      part={part}
      pageName={pageName}
      action={
        <PartCard
          key={part.id}
          selected={isPartSelected}
          onSelection={handleSelectClick}
          part={part}
          logOnSelection={logOnSelection}
          logOnClickPart={logOnClickPart}
        />
      }
    />
  );
};

PartView.propTypes = {
  pageName: PropTypes.string,
  part: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default memo(PartView);
